import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const isFor = ['Empleados de oficina que quieren terminar su trabajo en la mitad del tiempo.', 'Freelancers y Copywriters que necesitan elevar la calidad de sus entregables.', 'Emprendedores saturados que necesitan automatizar procesos mentales diarios.', 'Estudiantes que buscan una ventaja competitiva en el análisis de información.'];
const notFor = ['Desarrolladores de software que buscan programación avanzada de modelos.', 'Personas que buscan una "fórmula mágica" para hacerse ricos sin trabajar.', 'Usuarios que solo quieren jugar con la IA y no buscan resultados profesionales.'];
export function WhoIsFor() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8" data-id="element-167">
      <div className="max-w-6xl mx-auto" data-id="element-168">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-169">
          {/* IS FOR */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="glass-card rounded-3xl p-8 border-t-4 border-t-green-500/80" data-id="element-170">
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center" data-id="element-171">
              <span className="bg-green-500/20 text-green-400 p-2 rounded-lg mr-3" data-id="element-172">
                <CheckIcon className="w-6 h-6" data-id="element-173" />
              </span>
              Esto ES Para Ti Si...
            </h3>
            <ul className="space-y-6" data-id="element-174">
              {isFor.map((item, index) => <li key={index} className="flex items-start" data-id="element-175">
                  <CheckIcon className="w-5 h-5 text-green-400 mr-3 mt-1 flex-shrink-0" data-id="element-176" />
                  <span className="text-gray-300 text-lg" data-id="element-177">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* NOT FOR */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="glass-card rounded-3xl p-8 border-t-4 border-t-red-500/80" data-id="element-178">
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center" data-id="element-179">
              <span className="bg-red-500/20 text-red-400 p-2 rounded-lg mr-3" data-id="element-180">
                <XIcon className="w-6 h-6" data-id="element-181" />
              </span>
              Esto NO Es Para Ti Si...
            </h3>
            <ul className="space-y-6" data-id="element-182">
              {notFor.map((item, index) => <li key={index} className="flex items-start" data-id="element-183">
                  <XIcon className="w-5 h-5 text-red-400 mr-3 mt-1 flex-shrink-0" data-id="element-184" />
                  <span className="text-gray-300 text-lg" data-id="element-185">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}